var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("stepheader", { attrs: { step: _vm.step } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "body current",
          attrs: {
            id: "wizard2-p-0",
            role: "tabpanel",
            "aria-labelledby": "wizard2-h-0",
            "aria-hidden": "false",
          },
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c(
                "label",
                { staticClass: "form-label", attrs: { for: "telefono" } },
                [_vm._v("Telefono: *")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.indirizzo.telefono,
                    expression: "indirizzo.telefono",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", id: "telefono" },
                domProps: { value: _vm.indirizzo.telefono },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.indirizzo, "telefono", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c(
                "label",
                { staticClass: "form-label", attrs: { for: "email" } },
                [_vm._v("Email:")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.indirizzo.email,
                    expression: "indirizzo.email",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", id: "email" },
                domProps: { value: _vm.indirizzo.email },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.indirizzo, "email", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c(
                "label",
                { staticClass: "form-label", attrs: { for: "referente" } },
                [_vm._v("Referente:")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.indirizzo.referente,
                    expression: "indirizzo.referente",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", id: "referente" },
                domProps: { value: _vm.indirizzo.referente },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.indirizzo, "referente", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("buttons", {
            attrs: { buttons: _vm.step.buttons },
            on: { action: _vm.fireaction },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }